import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { chain, CreateDataForUnparse } from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/ExportWishList";
import translate from "@insite/client-framework/Translate";

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(chain, CreateDataForUnparse, props => {
   const { wishListLineCollection } = props.apiResult;
    if (!wishListLineCollection?.length) {
        return;
    }

    props.dataForUnparse = {
        fields: [
            translate("Item #"),
            translate("MFG #"),
            translate("Quantity"),
            translate("Unit of Measure"),
            translate("Manufacturer"),
            translate("Title"),
            translate("Price"),
            translate("Notes"),
            translate("Added on"),
            translate("Added by"),
        ],
        data: wishListLineCollection.map(o => [
            o.erpNumber,
            o.manufacturerItem,
            o.qtyOrdered.toString(),
            o.unitOfMeasure,
            o.brand?.name || "",
            o.shortDescription,
            o.quoteRequired ? "" : o.pricing?.unitRegularPrice?.toString() || "",
            o.notes,
            o.createdOn.toString(),
            o.createdByDisplayName,
        ]),
    };
});